import 'prismjs'
import 'prismjs/components/prism-armasm'
import 'prismjs/components/prism-apacheconf'
import 'prismjs/components/prism-aspnet'
import 'prismjs/components/prism-basic'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-c'
import 'prismjs/components/prism-cpp'
import 'prismjs/components/prism-csharp'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-dart'
import 'prismjs/components/prism-docker'
import 'prismjs/components/prism-ejs'
import 'prismjs/components/prism-git'
import 'prismjs/components/prism-go'
import 'prismjs/components/prism-graphql'
import 'prismjs/components/prism-groovy'
import 'prismjs/components/prism-haskell'
import 'prismjs/components/prism-java'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-json'
import 'prismjs/components/prism-jsx'
import 'prismjs/components/prism-kotlin'
import 'prismjs/components/prism-less'
import 'prismjs/components/prism-log'
import 'prismjs/components/prism-lua'
import 'prismjs/components/prism-markdown'
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-matlab'
import 'prismjs/components/prism-mongodb'
import 'prismjs/components/prism-nginx'
import 'prismjs/components/prism-perl'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-powershell'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-django'
import 'prismjs/components/prism-r'
import 'prismjs/components/prism-regex'
import 'prismjs/components/prism-ruby'
import 'prismjs/components/prism-rust'
import 'prismjs/components/prism-sass'
import 'prismjs/components/prism-scala'
import 'prismjs/components/prism-scss'
import 'prismjs/components/prism-sql'
import 'prismjs/components/prism-swift'
import 'prismjs/components/prism-tsx'
import 'prismjs/components/prism-typescript'
import 'prismjs/components/prism-visual-basic'
import 'prismjs/components/prism-wasm'
import 'prismjs/components/prism-yaml'

export const CodeSampleLanguages = [
    { text: 'Apache Configuration', value: 'apacheconf' },
    { text: 'ARM Assembly', value: 'armasm' },
    { text: 'ASP.NET', value: 'aspnet' },
    { text: 'Bash', value: 'bash' },
    { text: 'Basic', value: 'basic' },
    { text: 'C', value: 'c' },
    { text: 'C#', value: 'csharp' },
    { text: 'C++', value: 'cpp' },
    { text: 'CSS', value: 'css' },
    { text: 'Dart', value: 'dart' },
    { text: 'Django', value: 'django' },
    { text: 'Docker', value: 'docker' },
    { text: 'EJS', value: 'ejs' },
    { text: 'Git', value: 'git' },
    { text: 'Go', value: 'go' },
    { text: 'GraphQL', value: 'graphql' },
    { text: 'Groovy', value: 'groovy' },
    { text: 'Haskell', value: 'haskell' },
    { text: 'HTML/XML', value: 'markup' },
    { text: 'Java', value: 'java' },
    { text: 'JavaScript', value: 'javascript' },
    { text: 'JSON', value: 'json' },
    { text: 'Kotlin', value: 'kotlin' },
    { text: 'Markdown', value: 'markdown' },
    { text: 'MATLAB', value: 'matlab' },
    { text: 'MongoDB', value: 'mongodb' },
    { text: 'Nginx', value: 'nginx' },
    { text: 'LESS', value: 'less' },
    { text: 'Log', value: 'log' },
    { text: 'Lua', value: 'lua' },
    { text: 'Perl', value: 'perl' },
    { text: 'PHP', value: 'php' },
    { text: 'PowerShell', value: 'powershell' },
    { text: 'Python', value: 'python' },
    { text: 'R', value: 'r' },
    { text: 'React JSX', value: 'jsx' },
    { text: 'React TSX', value: 'tsx' },
    { text: 'Regex', value: 'regex' },
    { text: 'Ruby', value: 'ruby' },
    { text: 'Rust', value: 'rust' },
    { text: 'SASS', value: 'sass' },
    { text: 'Scala', value: 'scala' },
    { text: 'SCSS', value: 'scss' },
    { text: 'SQL', value: 'sql' },
    { text: 'Swift', value: 'swift' },
    { text: 'Typescript', value: 'typescript' },
    { text: 'Visual Basic', value: 'visual-basic' },
    { text: 'Web Assembly', value: 'wasm' },
    { text: 'YAML', value: 'yaml' },
]

export const plugins = [
    'codesample',
    'table',
    'lists',
    'code',
    'autoresize',
    'imatheq',
    'searchreplace',
]
